/**
 * 快购属性 swatch HTML 与商品角标（从 newklayi.js 抽离）
 */
(function () {
  const productVariantMarkers = {
    6950963970182: [
      {
        match: /7x5 HD Glueless-150%/,
        html: '<span class="markers_long">No-slip Cap</span>',
      },
      {
        match: /7x5 150%-No Baby Hair|20/,
        html: '<span class="markers_long">Fast Shipping</span>',
      },
      { match: /13x4 Drawstring-180%/, html: '<span class="markers_long">Limited Price Drop</span>' },
    ],
    7361238040710: [
      {
        match: /13x4 HD Real Scalp-150%|13x4 HD Real Scalp-180%/,
        html: '<span class="markers_long">New Drawstring</span>',
      },
    ],
    7325503291526: [
      { match: /20/, html: '<span class="markers_long">Hot</span>' },
      { match: /24/, html: '<span class="markers_long">Glam Length</span>' },
      {
        match: /7x5 Upgrade No Slip Cap/,
        html: '<span class="markers">Drawstring</span>',
      },
      {
        match: /Blonde Highlight/,
        html: '<span class="markers">Drawstring</span>',
      },
    ],
    5145247613062: [
      {
        match: /Lace band\+Drawstring-150%/,
        html: '<span class="markers_long">Free Upgrade</span>',
      },
    ],
    7288508612742: [
      {
        match: /13x4 Pre everything wig|20/,
        html: '<span class="markers">Hot</span>',
      },
      { match: /24/, html: '<span class="markers_long">@Ameera</span>' },
      {
        match: /7x5 Bye Bye Knots-180%/,
        html: '<span class="markers_long">@Ameera</span>',
      },
    ],
    6879878611078: [
      {
        match: /Layered Bob-180%/,
        html: '<span class="markers">Most Popular</span>',
      },
      { match: /14/, html: '<span class="markers_long">Model Length</span>' },
    ],
    7035831386246: [
      {
        match: /Kinky Straight/,
        html: '<span class="markers_long">Price Drop</span>',
      },
      {
        match: /24/,
        html: '<span class="markers_long">Model Length</span>',
      },
    ],
    7292759507078: [
      {
        match: /(?:13x4-150%|7x5-180%)\((Loose Wave|Layer Straight)\)/,
        html: '<span class="markers_long">Drawstring</span>',
      },

      // {
      //   match: /(?:13x4-150%|7x5-180%)\((Loose Wave|Layer Straight)\)/,
      //   html: '<span class="markers_long">Drawstring</span>',
      // },
      { match: /24/, html: '<span class="markers_long">Hot</span>' },
      {
        match: /7x5 Bye Bye Knots-180%/,
        html: '<span class="markers_long">+$10 Upgrade</span>',
      },
    ],
    6947525165190: [
      {
        match: /7x5 No Slip Cap-180%|13x4-150%|7x5-150%/,
        html: '<span class="markers_long">Drawstring</span>',
      },
    ],
    6870173712518: [
      { match: /20/, html: '<span class="markers 20">Hot</span>' },
      {
        match: /6x4-220%/,
        html: '<span class="markers">Side Part</span>',
      },
    ],
    7399530987654: [
      {
        match: /7x5 HD Glueless-Drawstring/,
        html: '<span class="markers 20">No Slip Cap</span>',
      },
      {
        match: /13x4 Pre Everything-Drawstring/,
        html: '<span class="markers 20">Limited Price Drop</span>',
      },
      { match: /24/, html: '<span class="markers_long">Influencer Pick</span>' },
      { match: /20/, html: '<span class="markers_long">Fast Shipping</span>' },
    ],
    7017476948102: [
      {
        match: /13x4 Pre-everything 2.0/,
        html: '<span class="markers">Pull&Go Drawstring</span>',
      },
      { match: /12/, html: '<span class="markers_long">@KIE</span>' },
      { match: /24/, html: '<span class="markers_long">Most Natural</span>' },
    ],
    7045879332998: [
      { match: /20/, html: '<span class="markers_long">24H Price Sale</span>' },
      { match: /24/, html: '<span class="markers_long">Most Choice</span>' },
    ],
    6970186203270: [
      {
        match: /7x5 Bye Bye Knots 4.0/,
        html: '<span class="markers">Hot</span>',
      },
      { match: /20|24/, html: '<span class="markers_long">Extra Gifts</span>' },
    ],
    7314787434630: [
      { match: /20/, html: '<span class="markers_long">$169 with Code</span>' },
      {
        match: /13x4 Pre everything-150%/,
        html: '<span class="markers_long">@Marie</span>',
      },
    ],
    7227657158790: [
      {
        match: /5x5 HD Glueless Lace-180%/,
        html: '<span class="markers 20">Hot</span><span class="markers_long">@Jess</span>',
      },
      { match: /20/, html: '<span class="markers_long">@Jess</span>' },
      { match: /24/, html: '<span class="markers_long">@Mercy</span>' },
    ],
    7283737886854: [
      {
        match: /13x4 Pre-everything Glueless/,
        html: '<span class="markers">Hot</span>',
      },
      { match: /24/, html: '<span class="markers_long">@Dom</span>' },
    ],
    7258963869830: [
      { match: /180%/, html: '<span class="markers_long">@Ameera Same</span>' },
    ],
    6858272931974: [
      { match: /180%|24/, html: '<span class="markers_long">Free Wig</span>' },
    ],
    6789140971654: [
      {
        match: /7x5 HD Glueless-Drawstring/,
        html: '<span class="markers_long">Model Same 4C Kinky Edge</span>',
      },
    ],
    6742635380870: [
      {
        match: /24/,
        html: '<span class="markers_long">Model Length</span>',
      },
    ],
    7411093897350: [
      {
        match: /Upgrade Front-Only Finger Coil Ends/,
        html: '<span class="markers_long">Glueless & No Slip Cap</span>',
      },
    ],
    7498698391686: [
      {
        match: /Full Finger Coil Ends/,
        html: '<span class="markers_long">@Kie Same Style</span>',
      },
      {
        match: /20=$147(Gifts)/,
        html: '<span class="markers long">Fast Shipping</span>',
      },
      {
        match: /7x5 Ombre Chestnut Brown-Drawstring/,
        html: '<span class="markers">No-Slip Cap</span>',
      },
    ],
  };
  function escapeQuickShopHtmlAttr(str) {
    return String(str || "")
      .replace(/&/g, "&amp;")
      .replace(/"/g, "&quot;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");
  }

  function normalizeQuickShopOptionText(str) {
    if (str == null) return "";
    return String(str).replace(/\s+/g, " ").trim();
  }

  function findQuickShopVariantById(productData, variantId) {
    if (!productData || !productData.variants || variantId == null) return null;
    const vid = String(variantId);
    return (
      productData.variants.find(function (v) {
        return String(v.id) === vid;
      }) || null
    );
  }

  function isQuickShopOptionValueActive(optionIndex, attributeValue, productData) {
    if (window.quickShopMode !== "cart-edit" || !window.cartEditContext) {
      return false;
    }
    const variant = findQuickShopVariantById(
      productData,
      window.cartEditContext.variantId
    );
    if (!variant) return false;
    const target =
      variant.options && variant.options[optionIndex] != null
        ? variant.options[optionIndex]
        : variant["option" + (optionIndex + 1)];
    if (target == null || target === undefined) return false;
    return (
      normalizeQuickShopOptionText(target) ===
      normalizeQuickShopOptionText(attributeValue)
    );
  }

  function getVariantMarkers(productId, option) {
    var result = {
      marker: "",
      marker_long: "",
    };

    const rules = productVariantMarkers[productId];
    if (!rules) return result;

    rules.forEach((rule) => {
      if (rule.match.test(option)) {
        if (rule.html.includes("markers_long")) {
          result.marker_long += rule.html;
        } else if (rule.html.includes("markers")) {
          result.marker += rule.html;
        }
      }
    });

    return result;
  }

  function normalizeQuickShopOptionValue(str) {
    if (str == null) return "";
    return String(str).replace(/\s+/g, " ").trim();
  }

  /** 取该选项值在 variants 中的代表变体（与详情页 data-variant-id 一致，多语言稳定） */
  function findRepresentativeVariantId(productData, optionIndex, optionValue) {
    if (!productData || !productData.variants || !productData.variants.length) {
      return "";
    }
    var target = normalizeQuickShopOptionValue(optionValue);
    for (var i = 0; i < productData.variants.length; i++) {
      var variant = productData.variants[i];
      if (!variant.options || !variant.options.length) continue;
      if (
        normalizeQuickShopOptionValue(variant.options[optionIndex]) === target
      ) {
        return String(variant.id);
      }
    }
    return "";
  }

  /** 快购属性：与详情 block 模式一致，供 klaiyi-option-images 注入属性图 */
  function buildQuickShopOptionSwatchesHtml(optionIndex, values, productData, productId) {
    const optionMeta =
      productData &&
      productData.options &&
      productData.options[optionIndex];
    const optionName = optionMeta && optionMeta.name ? optionMeta.name : "";
    let html =
      '<ul class="SizeSwatchList HorizontalList HorizontalList--spacingTight js-klaiyi-option-swatch-list">';

    values.forEach(function (attributes_list, n) {
      if (attributes_list == null || attributes_list === "") return;
      const inputId = "quick-shop-opt-" + optionIndex + "-" + n;
      const escapedVal = escapeQuickShopHtmlAttr(attributes_list);
      const activeForCartEdit = isQuickShopOptionValueActive(
        optionIndex,
        attributes_list,
        productData
      );
      const activeForDefault =
        window.quickShopMode !== "cart-edit" && n === 0;
      const isActive = activeForCartEdit || activeForDefault;
      const markers = getVariantMarkers(Number(productId), attributes_list);
      const repVariantId = findRepresentativeVariantId(
        productData,
        optionIndex,
        attributes_list
      );
      let giftHtml = "";
      if (String(attributes_list).indexOf("Gifts") >= 0) {
        giftHtml =
          '<img class="gift-pic" src="https://cdn.shopify.com/s/files/1/1720/3725/files/Frame_2085662403_39b7a1aa-4265-4032-98db-f362f512d85d.png?v=1744183354" width="22" height="22" alt="gift-pic">';
      }

      html +=
        '<li class="HorizontalList__Item">' +
        '<input id="' +
        inputId +
        '" class="SizeSwatch__Radio" type="radio" name="option-' +
        optionIndex +
        '" value="' +
        escapedVal +
        '"' +
        (isActive ? ' checked="checked"' : "") +
        ' data-option-position="' +
        (optionIndex + 1) +
        '">' +
        '<label for="' +
        inputId +
        '" class="SizeSwatch SizeSwatch--quickshop' +
        (isActive ? " is-active" : "") +
        '" data-value="' +
        escapedVal +
        '" data-option-name="' +
        escapeQuickShopHtmlAttr(optionName) +
        '" data-option-index="' +
        optionIndex +
        '" data-option-value-index="' +
        n +
        '"' +
        (repVariantId ? ' data-variant-id="' + repVariantId + '"' : "") +
        ">" +
        attributes_list +
        "</label>" +
        giftHtml +
        markers.marker +
        markers.marker_long +
        "</li>";
    });

    html += "</ul>";
    return html;
  }

  window.buildQuickShopOptionSwatchesHtml = buildQuickShopOptionSwatchesHtml;
})();